import React from 'react';
import { Box, Fab } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Karta from '../components/karta/Karta';
import Search from '../components/karta/Search';
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch } from 'react-redux';
import { toggleHomepageSearch } from '../store/slices/chitalishtaSlice';

const KartaPage = () => {
  const dispatch = useDispatch();

  const handleToggleSearch = () => {
    dispatch(toggleHomepageSearch());
  };

  return (
    <>
      <Helmet>
        <title>Карта на народните читалища в България</title>
        <meta name="description" content="Интерактивна карта на всички народни читалища в България" />
      </Helmet>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          width: '100%',
        }}
      >
        {/* Header */}
        <Header />

        {/* Main Content - Картата */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: '100%',
            height: 'calc(100vh - 64px - 200px)', // 64px header, 200px footer (приблизително)
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <Karta />
          <Search />
          <Fab
            color="primary"
            aria-label="toggle search"
            onClick={handleToggleSearch}
            sx={{
              position: 'absolute',
              top: '6px',
              left: '60px',
              zIndex: 1000,
            }}
          >
            <SearchIcon />
          </Fab>
        </Box>

        {/* Footer */}
        <Footer />
      </Box>
    </>
  );
};

export default KartaPage;